import { GET_MACHINE_LIST_Register } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
    MachineTypeList:[]
}

function MachineTypeRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_MACHINE_LIST_Register:
            return {
                ...state,
                MachineTypeList:action.payload.map(x=>({
                    Id:zeroPad(x.id,8),
                    description:x.description,
                    active:x.active                
                })) 
            }
        default:
           return state
    }  

}

export default MachineTypeRegister;